/** Просьба разрешить боту писать — представление без стора, всё приходит пропсами. */
import { Button, TAP_GUARD_MS, WindowShell } from "../kit";
import { useT } from "../../../app";

export interface WriteAccessViewProps {
  onAllow(): void;
  onDecline(): void;
}

export function WriteAccessView({ onAllow, onDecline }: WriteAccessViewProps) {
  const t = useT();
  return (
    <WindowShell kind="writeAccess" title={t("win.writeAccess.title")} guardMs={TAP_GUARD_MS}>
      <p class="win-text" data-testid="write-access-text">
        {t("win.writeAccess.text")}
      </p>
      <div class="win-actions">
        <Button tone="green" onClick={onAllow} data-testid="write-access-allow">
          {t("win.writeAccess.allow")}
        </Button>
        <Button tone="link" onClick={onDecline} data-testid="write-access-decline">
          {t("win.writeAccess.decline")}
        </Button>
      </div>
    </WindowShell>
  );
}
